// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__Y2r3C","col":"Table_col__1TBYf","fulfillmentStatus":"Table_fulfillmentStatus__3LAIG","emailCol":"Table_emailCol__3Ws32"};